// Dependencies
import React, { FunctionComponent } from 'react'

// Styles
import {
  Container,
  Description,
  Content,
  TitlePrimary,
  TitleSecondary,
  TitleWrapper,
  TextContainer,
  HerobannerItemContainer,
  Icon,
  Label,
  HighlightIndicator
} from './HeroBannerSisu.styles'

// Assets
import backgroundImage from 'assets/bg-gabarito.jpg'
import database from 'assets/database.svg'
import handCoins from 'assets/hand-coins.svg'
import herobannerHighlightIndicator from 'assets/herobanner-highlight-indicator.svg'

export const HeroBannerSisu: FunctionComponent = () => {
  return (
    <Container backgroundImage={backgroundImage}>
      <Content>
        <HeroBannerItem
          iconSrc={database}
          highlightVariant="database"
          label="Previsão baseada em dados reais!"
        />

        <TextContainer>
          <TitleWrapper>
            <TitleSecondary>SIMULADOR</TitleSecondary>

            <TitlePrimary>
              <strong>SiSU</strong> 2025
            </TitlePrimary>
          </TitleWrapper>

          <Description>
            Insira as suas notas do ENEM 2024 no formulário abaixo e
            descubra suas chances de entrar em uma universidade pública dos seus
            sonhos.
          </Description>
        </TextContainer>

        <HeroBannerItem
          iconSrc={handCoins}
          highlightVariant="handCoins"
          label="Totalmente gratuito!"
        />
      </Content>
    </Container>
  )
}

export const HeroBannerItem: FunctionComponent<any> = ({
  highlightVariant,
  label,
  iconSrc
}) => {
  return (
    <HerobannerItemContainer className="pdg-hero-item">
      <HighlightIndicator
        src={herobannerHighlightIndicator}
        variant={highlightVariant}
      />

      <Icon src={iconSrc} />

      <Label>{label}</Label>
    </HerobannerItemContainer>
  )
}
